<main [@fadeInOut] id="main-heading" role="main" tabindex="0">

  <div class="wrapper">
    <div class="container-fluid" id="wrapper">
        <form [formGroup]="erForm" novalidate #createForm="ngForm" tabindex="0" role="form">
          <app-custom-sidebar [sidebarExpanded]="true">
            <ejs-accordion #sidebarAccordion id="accordion_html_markup" expandMode='Multiple'
                           (expanding)="expanding($event)"
                           (clicked)="onClick($event)"
                           (keydown.enter)="onClick($event)">
              <e-accordionitems>
                <e-accordionitem expanded="true">
                  <ng-template #header>
                    <div class="container p-0">
                      <div class="row accordion-item-header">
                        <div class="container">
                          <div class="row p-0 m-0">
                            <div class="col-sm-9 p-0 form-name-div" tabindex="0">
                              <span>Establishment Registration</span>
                            </div>
                            <div class="col-sm-3" tabindex="0">
                              <span>Version</span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-sm-12 accordion-item-header no-padding">
                          <div class="container">
                            <div class="row">
                              <div class="col-sm-8 text-left no-padding text-wrap form-name-div" id="formName" tabindex="0">
                                <ejs-tooltip id="tooltipObj" #tooltipObj opensOn='custom' content=''  [enableHtmlParse]="false">
                                  <label class='tooltip-span padding-bottom-5' controlName="formName" (mouseenter)="showSFToolTip($event);" (mouseleave)="hideSFToolTip($event);"></label>
                                </ejs-tooltip>
                              </div>
                              <div class="col-sm-2" tabindex="0">
                                <a href="javascript:void(0);" (keydown.enter)="displayRevisionHistory($event)"
                                  role="link" tabindex="0" aria-label="display revision history"
                                  (click)="displayRevisionHistory($event)">
                                  <label class='version'  tabindex="0">{{versionToDisplay === '0.0' ? 'Draft' : versionToDisplay}}</label>
                                </a>
                              </div>
                              <div class="col-sm-2" [class.draft]="isDraftMode">
                                <span *ngIf="current" class="badge badge-success" tabindex="0">current</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </ng-template>
                  <ng-template #content>
                    <div class="container p-0">
                      <div class="row">
                        <div class="col-sm-6">
                          <label class="basic-componentlabel" tabindex="0">Status</label>
                        </div>
                        <div class="col-sm-6">
                          <label class="basic-componentlabel" tabindex="0">SPL Version</label>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-sm-6" tabindex="0">{{status}}</div>
                        <div class="col-sm-6" tabindex="0">{{splVersion}}</div>
                      </div>
                      <div class="row border-top">
                        <div class="col-sm-6">
                          <label for="setId" class="basic-componentlabel" tabindex="0">
                            Set Id
                          </label>
                        </div>
                        <div class="col-sm-6">
                          <button class="btn btn-default" id="btnGenerateSetId" (click)="generateGUID()"
                            tabindex="0" role="button" aria-label="New guid" (keydown.enter)="generateGUID()">
                            New GUID
                          </button>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-sm-12" id="setId">
                          <ejs-inplaceeditor id="setId" name='setId' mode="Popup"
                                             [model]="setIdModel" (actionBegin)="editorChanged($event)"
                                             [validationRules]="rules" type="Text" [value]="setId">
                          </ejs-inplaceeditor>
                        </div>
                      </div>
                      <div class="row border-top">
                        <div class="col-sm-6">
                          <label class="basic-componentlabel" tabindex="0">Last modified by</label>
                        </div>
                        <div class="col-sm-6">
                          <label class="basic-componentlabel" tabindex="0">Last modified date</label>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-sm-6">
                          <label tabindex="0">{{lastModifiedBy}}</label>
                        </div>
                        <div class="col-sm-6">
                          <label>{{lastModifiedDate}}</label>
                        </div>
                      </div>
                      <div class="row border-top">
                        <div class="col-sm-6">
                          <label class="basic-componentlabel" tabindex="0">Business categories</label>
                        </div>
                        <div class="col-sm-6">
                          <ejs-inplaceeditor name="ipeBusinessCategory" mode="Popup"
                                             type="DropDownList" [value]="formDetailData?.busCategory?.label"
                                             class="mt-3" [model]="businessCategoryModel"
                                             (actionBegin)="editorChanged($event)">
                          </ejs-inplaceeditor>
                        </div>
                      </div>
                    </div>
                  </ng-template>
                </e-accordionitem>
              </e-accordionitems>
            </ejs-accordion>
          </app-custom-sidebar>
            <div class="main-form">
              <div class="container">
                <div class="row ps-5">
                  <div class="col-sm-11">
                    <div class="row">
                      <div class="col-sm-12">
                        <h1 tabindex="0" aria-label="Establishment Registration" role="heading" aria-level="1">
                          {{isEditMode ? "Edit" : "New"}} Establishment Registration
                        </h1>
                      </div>
                    </div>
                    <div class="row padding-left-30 card-sticky" *ngIf="!current && formDetailData && (formDetailData.majorRevision !== 0 && formDetailData.majorRevision !== undefined)">
                      <div class="alert alert-warning text-center" role="alert" tabindex="0">
                        <i class="fas fa-exclamation-circle"></i>&nbsp;<b>NOT CURRENT VERSION</b> - Any changes made could overwrite a newer version of this form.
                      </div>
                    </div>
                    <div class="card mb-5">
                      <div class="card-body p-0">
                        <div>
                          <div>
                            <app-error-messages #errorMessages [splValidationMessages]='splValidationMessages'>
                            </app-error-messages>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="container px-0">
                      <div class="row">
                        <div class="col text-primary">
                          <h2 tabindex="0">Establishment Registration Details</h2>
                        </div>
                      </div>
                    </div>
                    <div class="container px-0">
                      <div class="row">
                        <div class="col-sm-12">
                          <div class="row">
                            <div class="mb-3 col-sm-5">
                              <label for="splSubmissionType">SPL submission type</label>
                              <ejs-dropdownlist #ddwSubmissionType [dataSource]='splSubmissionTypeDdwDS'
                                                [required]="splSubmissionTypeMissing" id="splSubmissionType"
                                                [fields]='splSubmissionTypeFields' [placeholder]='ddwWaterMark' showClearButton=true
                                                formControlName="splServiceTypeId" [popupHeight]='ddwHeight'
                                                (change)="ddwSelectionChanged($event, 'splSubmissionTypeId')" [popupWidth]='ddwWidth'
                                                [ngClass]="{ required:true, 'is-invalid': f.splServiceTypeId.errors && f.splServiceTypeId.errors.required }">
                              </ejs-dropdownlist>
                              <div *ngIf="formErrors?.splServiceTypeId" class="alert-text">
                                {{formErrors?.splServiceTypeId}}
                              </div>
                            </div>
                            <div class="mb-3 col-sm-5">
                              <label for="effectiveTime">SPL revision date</label>
                              <ejs-datepicker formControlName="effectiveTime" (open)="onOpen($event)"
                                              [ngClass]="getClass('effectiveTime')"
                                              placeholder='Select a date' class="extra-padding"
                                              (change)="revisionDateChanged($event)"
                                              [format]='dateFormat'>
                              </ejs-datepicker>
                              <div *ngIf="f.effectiveTime.errors && f.effectiveTime.errors.required" class="alert-text">
                                {{formErrors.effectiveTime}}
                              </div>
                            </div>
                            <div class="mb-3 col-sm-2">
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="container px-0">
                      <div class="row">
                        <div class="col">
                          <h2 tabindex="0" aria-label="Registrant Details" role="heading" aria-level="2">Registrant Details</h2>
                        </div>
                      </div>
                    </div>
                    <div class="container px-0">
                      <div class="row">
                        <div class="col-sm-12">
                          <div class="card">
                            <div class="card-header bg-primary">
                              <span class="text-white"  tabindex="0">Registrant Company</span>
                              <span class="float-end create-company-link">
                                  <a href="javascript:void(0);" (click)="showCompanyDialog('registrants')" [hidden]="restrictedSplSubmissionType"
                                  class="create-company-link" id="create-company"
                                  tabindex="0" role="link" aria-label="show create new company dialog" (keydown.enter)="showCompanyDialog('registrants')"
                                  >Create new company</a>
                              </span>
                            </div>
                            <div class="card-body basic-component">
                              <div class="container px-0">
                                <div class="row">
                                  <div class="col-sm-6">
                                    <label>Registrant company</label>
                                  </div>
                                  <div class="col-sm-6">
                                    <label>DUNS number</label>
                                  </div>
                                </div>
                                <div class="row">
                                  <div class="col-sm-6">
                                    <div class="container px-0">
                                      <div class="row">
                                        <div class="col-sm-10">
                                          <ejs-dropdownlist #registrantDdw [dataSource]='registrantCompaniesDdwDS'
                                                            (change)="ddwSelectionChanged($event, 'registrants')"
                                                            [fields]='ddwFields' [placeholder]='ddwWaterMark' showClearButton=true
                                                            id="registrantDdw" formControlName="registrantCompanyRevisionId"
                                                            [popupHeight]='ddwHeight' allowFiltering=true filterType="Contains"
                                                            [ngClass]="{ required:true, 'is-invalid': f.registrantCompanyRevisionId.errors && f.registrantCompanyRevisionId.errors.required }" [enabled]="!restrictedSplSubmissionType">
                                          </ejs-dropdownlist>
                                          <div *ngIf="formErrors?.registrantCompanyRevisionId" class="alert-text">
                                            {{formErrors?.registrantCompanyRevisionId}}
                                          </div>
                                        </div>
                                        <div class="col-sm-2">
                                          <div *ngIf="registrantCompanyRevisionId && !restrictedSplSubmissionType" class="view-link pt-0">
                                            <a href='javascript:void(0);' (click)="showCompanyDialog('registrants', erForm.value.registrantCompanyRevisionId)"
                                            tabindex="0" role="link" aria-label="view" (keydown.enter)="showCompanyDialog('registrants', erForm.value.registrantCompanyRevisionId)"
                                            >View</a>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="col-sm-6">
                                    <label *ngIf="registrantCompanyRevisionId" class="label-directive">{{erForm.value.registrantCompany.dunsNumber}}</label>
                                  </div>
                                  <div class="col float-start">
                                    <div *ngIf="isCompanyLatest('registrants', registrantCompany?.companyRevisionId ? registrantCompany?.companyRevisionId : 0)">
                                      <app-warning-icon [name]="registrantCompany?.companyName" [type]="iconTypeCompany"></app-warning-icon>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div *ngIf="registrantCompanyRevisionId && registrantContactRevisionId" class="container px-0 mt-2">
                      <div class="row">
                        <div class="col-sm-12">
                          <div class="card">
                            <div class="card-header bg-primary">
                              <span class="text-white" tabindex="0">Registrant Contact</span>
                            </div>
                            <div class="card-body basic-component">
                              <div class="container px-0">
                                <div class="row">
                                  <div class="col-sm-3">
                                    <label>Registrant contact</label>
                                  </div>
                                  <div class="col-sm-3">
                                    <label for="phoneNumber">Phone</label>
                                  </div>
                                  <div class="col-sm-3">
                                    <label>Email</label>
                                  </div>
                                  <div class="col-sm-3">
                                    <label>Address</label>
                                  </div>
                                </div>
                                <div class="row">
                                  <div *ngIf="registrantContactRevisionId" class="col-sm-3 pt-1">
                                    <label class="label-directive" tabindex="0">
                                      {{registrantContact.fullName}}
                                      <br/>
                                      <a *ngIf="!restrictedSplSubmissionType" href='javascript:void(0);' class="view-link" (click)="showContactDialog(registrantContactRevisionId)"
                                      tabindex="0" role="link" aria-label="view registrant contact" (keydown.enter)="showContactDialog(registrantContactRevisionId)"
                                      >View</a>
                                    </label>
                                  </div>
                                  <div class="col-sm-3 pt-1">
                                    <label class="label-directive" tabindex="0">
                                      {{registrantContact?.phoneArea}}
                                      {{registrantContact?.areaCode}}-
                                      {{registrantContact?.phone}}
                                      <span *ngIf="registrantContact?.phoneExt" tabindex="0">ext.</span>
                                      {{registrantContact?.phoneExt}}
                                    </label>
                                  </div>
                                  <div class="col-sm-3 pt-1">
                                    <label class="label-directive" tabindex="0">{{registrantContact.email}}</label>
                                  </div>
                                  <div class="col-sm-3 pt-1">
                                    <div class="col-sm-12 top-padding-small no-padding">
                                      <label class="label-directive" tabindex="0">{{registrantContact.address}}</label>
                                    </div>
                                    <div class="col-sm-12 pt-1 p-0">
                                      <label class="label-directive" tabindex="0">
                                        {{registrantContact.city}},
                                        {{getState(registrantContact.state)}} {{registrantContact.zip}}
                                        {{getCountryCode(registrantContact?.country?.id)}}
                                      </label>
                                    </div>
                                  </div>
                                </div>
                                <div class="row">
                                  <div *ngIf="isContactLatest(registrantContact?.contactRevisionId && registrantContact?.contactRevisionId)" class="col-sm-12 extra-padding">
                                    <app-warning-icon #warningContact [name]="registrantContact?.contactName ? registrantContact.contactName: registrantContact.fullName" [type]="iconTypeContact"></app-warning-icon>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="container mt-3 px-0">
                      <div class="row">
                        <div class="col">
                          <h2 tabindex="0" aria-label="Establishment Details" role="heading" aria-level="2">Establishment Details</h2>
                        </div>
                      </div>
                    </div>
                    <div class="container px-0 mt-3">
                      <div class="row">
                        <div class="col-sm-12">
                          <div class="">
                            <div class="">
                              <div class="container px-0">
                                <div class="row">
                                  <div class="col-sm-12">
                                    <table class="table table-inline estab-outer" formArrayName="establishments" role="table">
                                      <tbody>
                                      <tr formGroupName="{{i}}"
                                          *ngFor="let item of estabFormControls; let i = index; let last = last; let first = first">
                                        <td>
                                          <table class="table table-inline table-bordered estab-table estab-company-table" role="table">
                                            <thead>
                                            <tr class="label-text estab-company-head">
                                              <th role="columnheader" tabindex="0">Company</th>
                                              <th role="columnheader" tabindex="0">DUNS Number</th>
                                              <th role="columnheader" tabindex="0">FEI Number</th>
                                              <th role="columnheader" tabindex="0">Company Address</th>
                                              <th role="columnheader" tabindex="0">Contact Information</th>
                                              <th role="columnheader" tabindex="0" aria-label="Add or Remove"></th>
                                            </tr>
                                            </thead>
                                            <tbody role="rowgroup">
                                              <tr role="row" tabindex="0">
                                                <td class="td-30 px-0" role="gridcell" tabindex="0">
                                                <div class="col-sm-12 p-0">
                                                  <div class="container px-0">
                                                    <div class="row">
                                                      <div class="col-sm-10 ps-4">
                                                        <ejs-dropdownlist #estabCompanyDdw
                                                                          [dataSource]='estabCompaniesDdwDS'
                                                                          (change)="ddwSelectionChanged($event, 'establishments', i)"
                                                                          [fields]='ddwFields'
                                                                          [placeholder]='ddwWaterMark'
                                                                          showClearButton=true  allowFiltering=true filterType="Contains"
                                                                          formControlName="estabCompanyRevisionId"
                                                                          [popupHeight]='ddwHeight' [enabled]="!restrictedSplSubmissionType">
                                                        </ejs-dropdownlist>
                                                      </div>
                                                      <div class="col-sm-2 float-end view-link pe-3"
                                                           *ngIf="item.value.establishmentCompany?.companyRevisionId && !restrictedSplSubmissionType">
                                                           <a href='javascript:void(0);'
                                                           (click)="showCompanyDialog('establishments', item.value.establishmentCompany?.companyRevisionId, i)"
                                                           role="link" tabindex="0" aria-label="view company" (keydown.enter)="showCompanyDialog('establishments', item.value.establishmentCompany?.companyRevisionId, i)"
                                                           >View</a>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                                <div class="col-sm-12 alert-text extra-padding text-left" *ngIf="missingCompanyRevisionId('establishments', i) && submitted && !isDraftMode"
                                                [attr.aria-label]="validationMessages?.missingCompanyRevisionId.required" tabindex="0">
                                                  {{validationMessages?.missingCompanyRevisionId.required}}
                                                </div>
                                                <div *ngIf="item.value && isCompanyLatest('establishments', item.value.establishmentCompany?.companyRevisionId ? item.value.establishmentCompany?.companyRevisionId : 0, i)"
                                                     class="float-start ps-3">
                                                  <app-warning-icon [name]="item.value.establishmentCompany?.companyName" [type]="iconTypeCompany"></app-warning-icon>
                                                </div>
                                                <div *ngIf="item.value && item.value.establishmentCompany?.companyRevisionId"
                                                     class="pt-2 float-start ps-3">
                                                     <a href="javascript:void(0);"
                                                     (click)="showBusOps(item)"
                                                     tabindex="0" role="link" aria-label="view business operations" (keydown.enter)="showBusOps(item)">
                                                    View business operations
                                                  </a>
                                                </div>
                                              </td>
                                              <td class="td-10" role="gridcell" tabindex="0">
                                                                  <span>
                                                                    {{item.value.establishmentCompany?.dunsNumber}}
                                                                  </span>
                                              </td>
                                              <td class="td-10" role="gridcell" tabindex="0">
                                                                  <span>
                                                                    {{item.value.establishmentCompany?.fei}}
                                                                  </span>
                                              </td>
                                              <td class="td-20" role="gridcell" tabindex="0">

                                                <div *ngIf="item.value.establishmentCompany"
                                                     class="col-sm-12 top-padding-small no-padding">
                                                  <label class="label-directive" tabindex="0">{{item.value.establishmentCompany?.address}}</label>
                                                </div>
                                                <div class="col-sm-12 top-padding-small no-padding">
                                                  <label class="label-directive" tabindex="0">
                                                    {{item.value.establishmentCompany?.city}},
                                                    {{getState(item.value.establishmentCompany?.state)}}
                                                    {{item.value.establishmentCompany?.zip}}
                                                    {{getCountryCode(item.value.establishmentCompany?.country?.id)}}
                                                  </label>
                                                </div>
                                              </td>
                                              <td class="td-20">

                                                <div *ngIf="item.value.establishmentContact?.contactRevisionId && isContactLatest(item.value.establishmentContact?.contactRevisionId ? item.value.establishmentContact?.contactRevisionId : 0); else validContact"
                                                     class="col-sm-12 top-padding-small p-0">
                                                  <app-warning-icon #warningContact [name]="item.value.establishmentContact?.fullName" [type]="iconTypeContact"></app-warning-icon>
                                                </div>

                                                <ng-template #validContact>
                                                  <div *ngIf="item.value.establishmentContact"
                                                       class="col-sm-12 top-padding-small no-padding">
                                                    <label class="label-directive" tabindex="0">{{item.value.establishmentContact?.fullName}}</label>
                                                  </div>
                                                </ng-template>

                                                <div class="col-sm-12 top-padding-small no-padding">
                                                  <label class="label-directive" tabindex="0">{{item.value.establishmentContact?.address}}</label>
                                                </div>

                                                <div *ngIf="item.value.establishmentContact?.contactRevisionId"
                                                     class="col-sm-12 top-padding-small no-padding">
                                                  <label class="label-directive" tabindex="0">
                                                    {{item.value.establishmentContact?.city}},
                                                    {{getState(item.value.establishmentContact?.state)}}
                                                    {{item.value.establishmentContact?.zip}}
                                                    {{getCountryCode(item.value.establishmentContact?.country?.id) }}
                                                  </label>
                                                </div>
                                                <div *ngIf="item.value.establishmentContact?.contactRevisionId"
                                                     class="col-sm-12 top-padding-small no-padding">
                                                  <label class="label-directive" tabindex="0">
                                                    Phone:
                                                    {{item.value.establishmentContact?.phoneArea}}
                                                    {{item.value.establishmentContact?.areaCode}}-
                                                    {{item.value.establishmentContact?.phone}}
                                                    <span *ngIf="item.value.establishmentContact?.phoneExt">ext.</span>
                                                    {{item.value.establishmentContact?.phoneExt}}
                                                  </label>
                                                </div>
                                                <div *ngIf="item.value.establishmentContact?.contactRevisionId"
                                                     class="col-sm-12 top-padding-small no-padding">
                                                  <label class="label-directive" tabindex="0">
                                                    Email:
                                                    {{item.value.establishmentContact?.email}}
                                                  </label>
                                                </div>
                                              </td>
                                              <td class="td-10">
                                                <div class="container px-0">
                                                  <div class="row">
                                                    <div class="col-sm-12">
                                                      <div class="container px-0">
                                                        <div class="row">
                                                          <div class="col-sm-6">
                                                            <button *ngIf="estabFormControls.length > 1"
                                                                    class="btn btn-danger"
                                                                    [disabled]="restrictedSplSubmissionType"
                                                                    (click)="removeEstab(i)"
                                                                    tabindex="0" role="button" aria-label="remove establishment row" (keydown.enter)="removeEstab(i)">
                                                              <i class="fas fa-minus"
                                                                 title="Remove row"
                                                                 aria-label="Remove row"></i>
                                                            </button>
                                                          </div>
                                                          <div class="col-sm-6">
                                                            <button class="btn btn-success"
                                                                    *ngIf="last" (click)="addEstab()" [disabled]="restrictedSplSubmissionType"
                                                                    tabindex="0" role="button" aria-label="add establishment row" (keydown.enter)="addEstab()">
                                                              <i class="fas fa-plus"
                                                                 title="Add row"
                                                                 aria-label="Add row"></i>
                                                            </button>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>

                                              </td>
                                            </tr>
                                            <tr *ngIf="item.value.establishmentCompany?.country?.id && +item.value.establishmentCompany?.country?.id !== +usBasedCode && +item.value.establishmentCompany?.country?.id !== +usUMICode">
                                              <td colspan="6">
                                                <table class="table table-inline table-bordered estab-usagent-table">
                                                  <thead>
                                                  <tr class="label-text">
                                                    <th role="columnheader" tabindex="0">US Agent Company Name</th>
                                                    <th role="columnheader" tabindex="0">US Agent Company DUNS</th>
                                                    <th role="columnheader" tabindex="0">Contact</th>
                                                    <th role="columnheader" tabindex="0">Contact Email</th>
                                                    <th role="columnheader" tabindex="0">Contact Phone</th>
                                                  </tr>
                                                  </thead>
                                                  <tbody>
                                                  <tr>
                                                    <td class="td-30 px-0" role="gridcell" tabindex="0">
                                                      <div class="col-sm-12 p-0">
                                                        <div class="container px-0">
                                                          <div class="row">
                                                            <div class="col-sm-10 pt-2 pb-2">
                                                              <ejs-dropdownlist #estabCompany
                                                                                [dataSource]='estabUsAgentCompaniesDdwDS'
                                                                                (change)="ddwSelectionChanged($event, 'usAgents', i)"
                                                                                [fields]='ddwFields'
                                                                                [placeholder]='ddwWaterMark'
                                                                                showClearButton=true allowFiltering=true filterType="Contains"
                                                                                formControlName="usAgentCompanyRevisionId"
                                                                                [popupHeight]='ddwHeight' [enabled]="!restrictedSplSubmissionType">
                                                              </ejs-dropdownlist>
                                                            </div>
                                                            <div class="col-sm-2 float-end view-link pe-3"
                                                                 *ngIf="item.value.usAgentCompanyRevisionId && !restrictedSplSubmissionType">
                                                                 <a href='javascript:void(0);' (click)="showCompanyDialog('usAgents', item.value.usAgentCompany?.companyRevisionId, i)"
                                                                 role="link" tabindex="0" aria-label="view company" (keydown.enter)="showCompanyDialog('usAgents', item.value.usAgentCompany?.companyRevisionId, i)"
                                                                 >View</a>
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div>
                                                      <div class="col-sm-12 alert-text extra-padding text-left" *ngIf="missingCompanyRevisionId('usagents', i) && submitted"
                                                      [attr.aria-label]="validationMessages?.missingCompanyRevisionId.required" tabindex="0">
                                                        {{validationMessages?.missingCompanyRevisionId.required}}
                                                      </div>
                                                      <div *ngIf="item.value && isCompanyLatest('usAgents', item.value.usAgentCompany?.companyRevisionId ? item.value.usAgentCompany?.companyRevisionId : 0, i)"
                                                           class="float-start ps-3">
                                                        <app-warning-icon [name]="item.value.usAgentCompany?.companyName" [type]="iconTypeCompany"></app-warning-icon>
                                                      </div>

                                                    </td>
                                                    <td class="td-15" role="gridcell" tabindex="0">
                                                                          <span tabindex="0">
                                                                            {{item.value.usAgentCompany?.dunsNumber}}
                                                                          </span>
                                                    </td>
                                                    <td class="td-20" role="gridcell" tabindex="0">

                                                      <div *ngIf="item.value.usAgentContact?.contactRevisionId && isContactLatest(item.value.usAgentContact?.contactRevisionId ? item.value.usAgentContact?.contactRevisionId : 0); else validContact"
                                                           class="float-start ps-3">
                                                        <app-warning-icon #warningContact [name]="item.value.usAgentContact?.fullName" [type]="iconTypeContact"></app-warning-icon>
                                                      </div>

                                                      <ng-template #validContact>
                                                                            <span tabindex="0">
                                                                              {{item.value.usAgentContact?.fullName}}
                                                                            </span>
                                                      </ng-template>
                                                    </td>
                                                    <td class="td-20" role="gridcell" tabindex="0">
                                                      <div *ngIf="item.value.establishmentCompany"
                                                           class="col-sm-12 top-padding-small no-padding">
                                                        <label class="label-directive" tabindex="0">{{item.value.usAgentContact?.email}}</label>
                                                      </div>

                                                    </td>
                                                    <td class="td-15">
                                                      <div *ngIf="item.value.establishmentContact"
                                                           class="col-sm-12 top-padding-small no-padding">
                                                        <label class="label-directive" tabindex="0">
                                                          {{item.value.usAgentContact?.phoneArea}}
                                                          {{item.value.usAgentContact?.areaCode}}<span *ngIf="item.value.usAgentContact?.areaCode">-</span>
                                                          {{item.value.usAgentContact?.phone}}
                                                          <span *ngIf="item.value.usAgentContact?.phoneExt">ext.</span>
                                                          {{item.value.usAgentContact?.phoneExt ? item.value.usAgentContact?.phoneExt : item.value.usAgentContact?.phoneExtension}}
                                                        </label>
                                                      </div>
                                                    </td>

                                                  </tr>
                                                  </tbody>
                                                </table>
                                              </td>
                                            </tr>
                                            <tr *ngIf="item.value && item.value.establishmentCompany?.country?.id && +item.value.establishmentCompany?.country?.id !== +usBasedCode && +item.value.establishmentCompany?.country?.id !== +usUMICode">
                                              <td colspan="6">
                                                <table formArrayName="importers"
                                                       class="table table-inline table-bordered estab-usagent-table" role="table">
                                                  <thead>
                                                  <tr class="label-text">
                                                    <th>Importer Company Name</th>
                                                    <th role="columnheader" tabindex="0">Importer Company DUNS</th>
                                                    <th role="columnheader" tabindex="0">Contact</th>
                                                    <th role="columnheader" tabindex="0">Contact Email</th>
                                                    <th role="columnheader" tabindex="0">Contact Phone</th>
                                                    <th role="columnheader" tabindex="0" aria-label="Add or remove importer"></th>
                                                  </tr>
                                                  </thead>
                                                  <tbody>
                                                  <tr formGroupName="{{x}}"
                                                      *ngFor="let importer of importersArray(i).controls; let x = index; let last = last; let first = first">
                                                    <td class="td-30">
                                                      <div class="col-sm-12 p-0">
                                                        <div class="container px-0">
                                                          <div class="row">
                                                            <div class="col-sm-10 pt-2">
                                                              <ejs-dropdownlist #estabCompany
                                                                                [dataSource]='estabImporterCompaniesDdwDS'
                                                                                (change)="ddwSelectionChanged($event, 'importers', i, x)"
                                                                                [fields]='ddwFields'
                                                                                [placeholder]='ddwWaterMark'
                                                                                showClearButton=true allowFiltering=true filterType="Contains"
                                                                                formControlName="importerCompanyRevisionId"
                                                                                [popupHeight]='ddwHeight' [enabled]="!restrictedSplSubmissionType">
                                                              </ejs-dropdownlist>
                                                            </div>
                                                            <div class="col-sm-2 pt-2"
                                                                 *ngIf="importer.value.importerCompany?.companyRevisionId && !restrictedSplSubmissionType">
                                                                 <a href='javascript:void(0);'
                                                                 (click)="showCompanyDialog('importers', importer.value.importerCompany?.companyRevisionId ? importer.value.importerCompany?.companyRevisionId : 0, i, x)"
                                                                 role="link" tabindex="0" aria-label="view company" (keydown.enter)="showCompanyDialog('importers', importer.value.importerCompany?.companyRevisionId ? importer.value.importerCompany?.companyRevisionId : 0, i, x)"
                                                                 >View</a>
                                                            </div>
                                                          </div>
                                                          <div *ngIf="importer.value && isCompanyLatest('importers', importer.value.importerCompany?.companyRevisionId ? importer.value.importerCompany?.companyRevisionId : 0, i, x)">
                                                            <div class="float-start ps-3">
                                                              <app-warning-icon [name]="importer.value.importerCompany?.companyName" [type]="iconTypeCompany"></app-warning-icon>
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </td>
                                                    <td class="td-15" role="gridcell" tabindex="0">
                                                                          <span tabindex="0">
                                                                            {{importer.value.importerCompany?.dunsNumber}}
                                                                          </span>
                                                    </td>
                                                    <td class="td-15" role="gridcell" tabindex="0">
                                                      <div class="container px-0">
                                                        <div class="row">
                                                          <div class="col-sm-12">
                                                            <div *ngIf="importer.value.importerContact?.contactRevisionId && isContactLatest( importer.value.importerContact?.contactRevisionId ? importer.value.importerContact?.contactRevisionId : 0); else validContact"
                                                                 class="float-start ps-3">
                                                              <app-warning-icon [name]="importer.value.importerContact?.fullName" [type]="iconTypeCompany"></app-warning-icon>
                                                            </div>
                                                          </div>
                                                        </div>
                                                        <div class="row">
                                                          <div class="col-sm-12">
                                                            <ng-template #validContact>
                                                                                          <span tabindex="0">
                                                                                            {{importer.value.importerContact?.fullName }}
                                                                                          </span>
                                                            </ng-template>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </td>
                                                    <td class="td-15">

                                                      <div class="col-sm-12 top-padding-small no-padding">
                                                        <label class="label-directive" tabindex="0">
                                                          {{importer.value.importerContact?.email}}
                                                        </label>
                                                      </div>
                                                    </td>
                                                    <td class="td-15">
                                                      <div *ngIf="item.value.establishmentContact"
                                                           class="col-sm-12 top-padding-small no-padding">
                                                        <label class="label-directive" tabindex="0">
                                                          {{importer.value.importerContact?.phoneArea}}
                                                          {{importer.value.importerContact?.areaCode}}-
                                                          {{importer.value.importerContact?.phone}}
                                                          <span *ngIf="importer.value.importerContact?.phoneExt">ext.</span>
                                                          {{importer.value.importerContact?.phoneExt}}
                                                        </label>
                                                      </div>
                                                    </td>
                                                    <td class="td-15">
                                                      <div class="col-sm-12">
                                                        <div class="container px-0">
                                                          <div class="row">
                                                            <div class="col-sm-6">
                                                              <button *ngIf="importersArray(i).controls.length > 0"
                                                                      class="btn btn-danger btn-sm"
                                                                      (click)="removeImporter(i, x)"
                                                                      [disabled]="restrictedSplSubmissionType"
                                                                      role="button" tabindex="0" aria-label="remove importer row" (keydown.enter)="removeImporter(i, x)">
                                                                <i class="fas fa-minus"
                                                                   title="Remove row"
                                                                   aria-label="Remove row"></i>
                                                              </button>
                                                            </div>
                                                            <div class="col-sm-6">
                                                              <button class="btn btn-success btn-sm"
                                                                      *ngIf="last"
                                                                      (click)="addImporter(i)"
                                                                      [disabled]="restrictedSplSubmissionType"
                                                                      role="button" tabindex="0" aria-label="add importer row" (keydown.enter)="addImporter(i)">
                                                                <i class="fas fa-plus"
                                                                   title="Add row"
                                                                   aria-label="Add row"></i>
                                                              </button>
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </td>
                                                  </tr>
                                                  </tbody>
                                                </table>
                                              </td>
                                            </tr>
                                            </tbody>
                                          </table>
                                        </td>
                                      </tr>
                                      </tbody>
                                    </table>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row sticky extra-top-space" style="margin-bottom: 100px;">
                      <div class="col-sm-12  center-block buttons-bar">

                        <div class="float-start text-start sidebar-back-to">
                          <span class="padding-left-12 margin-right">
                            <a href="/er-form-dashboard" role="link" tabindex="0" aria-label="back to list">
                              <i class="fas fa-angle-left" aria-hidden="true"></i>
                              Back to list
                            </a>
                          </span>
                        </div>
                        <span class="margin-right">
                          <button class="btn btn-info" id="btnSaveDraft"
                                  (click)="saveERForm(true, false, false, false)"
                                  [disabled]="!bHasPermission || pageLoading"
                                  role="button" tabindex="0" aria-label="Save a draft" (keydown.enter)="saveERForm(true, false, false, false)">
                            Save a draft
                            <span *ngIf="saveLoading">
                              <img src="../../../assets/images/loading-info.gif" />
                            </span>
                          </button>
                        </span>
                        <span class=" margin-right">
                          <button class="btn btn-warning" (click)="validateERform()"
                                  [disabled]="!bHasPermission || pageLoading"
                                  role="button" tabindex="0" aria-label="Validate" (keydown.enter)="validateERform()">
                            Validate
                            <span *ngIf="validateLoading">
                              <img src="../../../assets/images/loading-orange.gif" />
                            </span>
                          </button>
                        </span>
                        <span class="build-spl">
                          <button class="build-spl-button" (click)="buildERModal()"
                                  [disabled]="!bHasPermission || pageLoading"
                                  role="button" tabindex="0" aria-label="build spl" (keydown.enter)="buildERModal()">
                            <span class="vertical-middle">Build SPL</span>
                            <span *ngIf="buildLoading">
                              <img src="../../../assets/images/loading-green.gif" />
                            </span>
                          </button>
                          <ejs-checkbox #splCheckbox cssClass="e-small padding-right vertical-middle"
                                        [disabled]="!bHasPermission || pageLoading" label="Ignore warnings"
                                        (change)="ignoreWarningsToggle()">fgf</ejs-checkbox>
                        </span>

                        <app-delete-button *ngIf="hasDeletePermission" #deleteButton
                                           [isDraft]="isDraftMode"
                                           [revisionId]="erRevisionId"
                                           [canDelete]="!!erRevisionId"
                                           [apiController]="'ERForms'"
                                           [redirectPage]="'er-form-dashboard'"
                                           [(pageLoading)]="pageLoading"></app-delete-button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
        </form>
    </div>
  </div>



  <ejs-dialog #revHistoryDialog id="revHistoryDialog" [isModal]='isModal' [animationSettings]='animationSettings'
    [closeOnEscape]='true' [showCloseIcon]='false' [width]='modalWidth' [position]='position' [height]='modalHeight'
    (overlayClick)="onOverlayClick()" [visible]='revHistoryVisible'>
    <div class="card">
        <div class="card-header bg-primary">
          <h4 class="card-title text-white" tabindex="0" aria-label="Version History" role="heading" aria-level="4"> Version History</h4>
        </div>
        <div class="card-body">
            <table class="table table-inner table-striped" role="table">
              <thead role="rowgroup">
                <th role="columnheader" tabindex="0" aria-label="Form version">Form version</th>
                <th role="columnheader" tabindex="0" aria-label="Modified By">Modified By</th>
                <th role="columnheader" tabindex="0" aria-label="Modified Date">Modified Date</th>
            </thead>
              <tbody role="rowgroup">
                <tr *ngFor="let item of erRevisions; let i = index;" role="row">
                    <td role="gridcell" tabindex="0">
                        <a href="javascript:void(0);" (click)="goToRevision(item.erRevisionId)"
                        role="link" tabindex="0" aria-label="go to revision" (keydown.enter)="goToRevision(item.erRevisionId)">{{item.formVersion}}</a>
                    </td>
                    <td role="gridcell" tabindex="0">{{item.modifiedBy }}</td>
                    <td role="gridcell" tabindex="0">{{item.modifiedDate | dateToLocale: 'true'}}</td>

                </tr>
            </tbody>
            </table>
        </div>
        <div class="text-center">
          <button id="revHistClose" class="btn btn-default" (click)="revisionHistoryClose($event)" data-ripple="true"
          role="button" tabindex="0" aria-label="close" (keydown.enter)="revisionHistoryClose($event)">
              Close
          </button>
        </div>
    </div>
  </ejs-dialog>

  <ejs-dialog #buildModalDialog [isModal]='isModal' [buttons]='buildDlgButtons' [visible]='buildModalDialogVisible'
    [position]='position' [animationSettings]='animationSettings'
    [width]='modalWidth' (open)="splVersionModalOpen()">
    <ng-template #content>
        <div class="card">
            <div class="card-header bg-primary">
              <h3 class="card-title text-white" tabindex="0" aria-label="Update SPL Version Number" role="heading" aria-level="3">Update SPL Version Number</h3>
            </div>
            <div class="card-body">
                <label tabindex="0">The SPL Version number will be updated to the next major version below</label>
                <input id='splVersionModalInput' type="number" min="1"
                    oninput="this.value = Math.abs(this.value) || this.value > 0" class="form-control"
                    (blur)="validateSplVersionInput($event)" role="spinbutton" tabindex="0" aria-label="spl version number input" />

                    <div *ngIf="invalidSplVersion" class="alert-text">
                       <span tabindex="0">The SPL version can't be blank</span>
                    </div>
            </div>
        </div>
    </ng-template>
  </ejs-dialog>

  <ejs-dialog #busOpsDialog [isModal]='isModal' [visible]='busOpsDialogVisible' (overlayClick)="onBusOpsOverlayClick()"
    [position]='position' [animationSettings]='animationSettings' [width]='modalWidth'>
    <ng-template #content>
        <div class="card">
            <div class="card-header bg-primary">
                <h4 class="card-title text-white" tabindex="0" aria-label="Business Operations Details" role="heading" aria-level="4"> Business Operations Details</h4>
            </div>
            <div class="card-body">
                <h5 tabindex="0" [attr.aria-label]="companyName" role="heading" aria-level="5">
                    {{companyName}}
                </h5>

                <table class="table table-inner table-bordered" role="table">
                    <thead role="rowgroup">
                        <th class="text-center" role="columnheader" tabindex="0" aria-label="Business Operation">Business Operation</th>
                        <th class="text-center" role="columnheader" tabindex="0" aria-label="Qualifiers">Qualifiers</th>
                    </thead>
                    <tbody *ngIf="businessOperations && businessOperations.length > 0" role="rowgroup">
                        <tr *ngFor="let busOp of businessOperations; let i = index;" role="row">

                            <td class="td-40" role="gridcell" tabindex="0">{{busOp.label }}</td>
                            <td role="gridcell" tabindex="0">
                                <table class="table table-inner">
                                    <tr *ngFor="let qualifier of busOp.relatedKeys; let q = index;" role="row">
                                        <td>{{qualifier.label}}</td>
                                    </tr>
                                </table>
                            </td>
                        </tr>
                    </tbody>
                    <tbody  *ngIf="!businessOperations || businessOperations.length === 0">
                      <tr>
                        <td class="text-left" colspan="2" role="gridcell" tabindex="0">Business operations not found</td>
                      </tr>
                    </tbody>
                </table>
            </div>
            <div class="text-center">
                <button class="btn btn-default" (click)="onBusOpsCloseClicked($event)" data-ripple="true"
                role="button" aria-label="close" tabindex="0" (keydown.enter)="onBusOpsCloseClicked($event)">
                    Close
                </button>
            </div>
        </div>
    </ng-template>
  </ejs-dialog>

  <div *ngIf="pageLoading">
  <div id="loading"></div>
  </div>

  <!-- Company Detail Dialog box -->
  <ejs-dialog id='dialog' #companyDialog isModal='true'
              [animationSettings]='animationSettings' [visible]='hidden' width="80%">
      <ng-template #content class="modal-header">
          <form name="modalCompanyForm" role="form" tabindex="0">
              <div class="card">
                  <div class="card-header bg-primary">
                    <h4 class="card-title text-white" tabindex="0" aria-label="Company Details" role="heading" aria-level="4">Company Details</h4>
                  </div>

                  <div class="card-body">
                      <app-company-details #companyDetails (companyOutput)="modalCompany($event)"
                          (cancelButtonClickedOutput)="companyDialogCancelButtonClicked()"
                          [parentComponentInput]="parentComponent">
                      </app-company-details>
                  </div>

              </div>

          </form>
      </ng-template>
  </ejs-dialog>


  <!-- Contact Detail Dialog box -->
  <div class="row">
  <div #container class='root-container'></div>
  <ejs-dialog id='dialog' #contactDialog isModal='true' [animationSettings]='animationSettings' [visible]='hidden' width="80%">
      <ng-template #content class="modal-header">
          <form name="modalContactForm" role="form" tabindex="0">
              <div class="card">
                <div class="card-header bg-primary">
                  <h4 class="card-title text-white" tabindex="0" aria-label="Company Details" role="heading" aria-level="4">Contact Details</h4>
              </div>
                  <div class="card-body">
                      <app-contact #contact (contactOutput)="modalContact($event)"
                      (cancelButtonClickedOutput)="contactDialogCancelButtonClicked()"
                      (contactRetrievedOutput)="contactRetrieved(contact)"
                      [parentComponentInput]="parentComponent">
                      </app-contact>
                  </div>
              </div>
          </form>
      </ng-template>
  </ejs-dialog>
  </div>

  <ejs-dialog #confirmDialog [isModal]='isModal' [buttons]='confirmDlgButtons' [visible]='hidden'
      [position]='position' [animationSettings]='animationSettings' [width]='modalWidth'  (overlayClick)="onSPLTypeOverlayClick()">
      <ng-template #content>
        <div class="card">
          <div class="card-header bg-primary">
            <h3 class="card-title text-white" tabindex="0" [attr.aria-label]="splSubmissionTypeName" role="heading" aria-level="3">{{splSubmissionTypeName}}</h3>
          </div>
          <div class="card-body" tabindex="0">
            The FDA will not allow changes to an Establishment Registration with this Document type.  We will revert your changes and proceed with the No Change Notification or Out of Business Notification.
          </div>
        </div>
      </ng-template>
  </ejs-dialog>
</main>
